import { useIsCurrentNetworkExternal } from '../currentUserNetworks';
import { useCurrentSessionUserField } from '../session';

type UseShowStorylineAdminSettings = () => boolean;
export const useShowStorylineAdminSettings: UseShowStorylineAdminSettings = () => {
  const isNetworkAdmin = !!useCurrentSessionUserField('isNetworkAdmin');
  const isNetworkExternal = useIsCurrentNetworkExternal();

  return isNetworkAdmin && !isNetworkExternal;
};
